<template>
  <el-dialog
    title="预览"
    :visible.sync="dialogShow"
    custom-class="preview-content-dialog"
    width="800px"
    @close="clickClose"
    :close-on-click-modal="false"
  >
    <div class="imgContent">
      <div class="content_wrap">
        <div class="img_wrap">
          <img
            class="img"
            :src="entryType === 'doctor' ? previewImgDoctor : previewImgDeputy"
            alt=""
          />
          <el-carousel
            v-if="isCanSort"
            class="banner_carousel"
            :class="entryType === 'doctor' ? 'doctor' : 'deputy'"
            trigger="click"
            height="110px"
            :interval="5000"
          >
            <el-carousel-item v-for="(item, index) in sortingData" :key="index">
              <img class="banner" :src="item.image_url" alt="" />
            </el-carousel-item>
          </el-carousel>
          <img
            v-if="!isCanSort"
            class="single_banner"
            :class="entryType === 'doctor' ? 'doctor' : 'deputy'"
            :src="itemData.image_url"
            alt=""
          />
          <img
            :src="enterpriseLogo"
            :class="entryType === 'doctor' ? 'doctor' : 'deputy'"
            class="logo"
            alt=""
          />
        </div>
        <div v-if="isCanSort" class="operation_wrap">
          <div class="preview_banner_box">
            <div
              class="preview_img"
              :class="{ 'is-selected': selectedItemIndex === index }"
              v-for="(item, index) in sortingData"
              :key="item.banner_id"
              @click="selectedItemIndex = index"
            >
              <img class="banner_show" :src="item.image_url" />
            </div>
          </div>
          <div class="operation-button">
            <i
              class="my-icon el-icon-top"
              :class="{ disabled: selectedItemIndex === 0 || selectedItemIndex === null }"
              @click="handleSort('up')"
            ></i>
            <i
              class="my-icon el-icon-bottom"
              :class="{
                disabled:
                  selectedItemIndex === sortingData.length - 1 || selectedItemIndex === null,
              }"
              @click="handleSort('down')"
            ></i>
          </div>
        </div>
      </div>
      <p class="intro">
        {{ entryTypeText }}
      </p>
    </div>
    <span v-if="isCanSort" slot="footer" class="dialog-footer">
      <el-button @click="clickClose">取 消</el-button>
      <el-button type="primary" @click="clickConfirm">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { IMG_SRC, BannerEntryType } from '@/utils/constant';
import nth from 'lodash/nth';
import cloneDeep from 'lodash/cloneDeep';
const { previewImgDoctor, previewImgDeputy } = IMG_SRC;

export default {
  name: 'OprationDialogPreview',
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false,
    },
    entryType: {
      type: String,
      default: 'doctor',
    },
    itemData: {
      type: Object,
      default: () => ({}),
    },
    enterpriseLogo: {
      type: String,
      default: '',
    },
    onlineData: {
      type: Array,
      default: () => [],
    },
    // 是否新增上线banner
    isNewItemSort: {
      type: Boolean,
      default: false,
    },
    isCanSort: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogShow: this.dialogFormVisible,
      previewImgDoctor,
      previewImgDeputy,
      sortingData: [],
      selectedItemIndex: null,
    };
  },
  computed: {
    entryTypeText() {
      return BannerEntryType[this.entryType].text;
    },
  },
  watch: {},
  mounted() {
    this.sortingData = cloneDeep(
      this.isNewItemSort ? [...this.onlineData, this.itemData] : this.onlineData,
    );
  },
  methods: {
    clickClose() {
      this.$emit('hideDialog');
    },
    handleSort(arrow) {
      if (this.selectedItemIndex === null) return;
      if (arrow === 'up') {
        if (this.selectedItemIndex !== 0) {
          const selectedObj = nth(this.sortingData, this.selectedItemIndex);
          const filterData = this.sortingData.filter((item, i) => i !== this.selectedItemIndex);
          this.sortingData = [
            ...filterData.slice(0, this.selectedItemIndex - 1),
            selectedObj,
            ...filterData.slice(this.selectedItemIndex - 1),
          ];
          this.selectedItemIndex = this.selectedItemIndex - 1;
        }
        return;
      }
      if (arrow === 'down') {
        if (this.selectedItemIndex !== this.sortingData.length - 1) {
          const selectedObj = nth(this.sortingData, this.selectedItemIndex);
          const filterData = this.sortingData.filter((item, i) => i !== this.selectedItemIndex);
          this.sortingData = [
            ...filterData.slice(0, this.selectedItemIndex + 1),
            selectedObj,
            ...filterData.slice(this.selectedItemIndex + 1),
          ];
          this.selectedItemIndex = this.selectedItemIndex + 1;
        }
        return;
      }
    },
    // 确定
    async clickConfirm() {
      this.$emit(
        'clickConfirm',
        this.sortingData.map((item, index) => ({
          banner_id: item.banner_id,
          sort: index + 1,
        })),
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.preview-content-dialog {
  ::v-deep &.el-dialog {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin-top: 0 !important;
  }
  .imgContent {
    .content_wrap {
      display: flex;
      align-items: center;
      justify-content: space-around;
      height: 544px;
      .img_wrap {
        position: relative;
        margin: 0 auto;
        .img {
          width: 259px;
          height: 544px;
          display: block;
          margin: 16px auto;
          object-fit: contain;
        }
        .single_banner {
          position: absolute;
          width: 243px;
          height: 110px;
          top: 128px;
          left: 8px;
          &.deputy {
            top: 110px;
          }
        }
        .banner_carousel {
          position: absolute;
          width: 243px;
          height: 110px;
          top: 128px;
          left: 8px;
          &.deputy {
            top: 110px;
          }
          ::v-deep .el-carousel__indicator--horizontal {
            padding: 2px 4px;
            .el-carousel__button {
              width: 22px;
            }
          }
          .banner {
            width: 243px;
            height: 110px;
          }
        }
      }

      .operation_wrap {
        height: 100%;
        width: 362px;
        background: #f7f9fc;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 36px 0;
        .preview_banner_box {
          display: flex;
          flex-direction: column;
          height: 100%;
          overflow-y: scroll;
          // justify-content: space-between;
          .preview_img {
            width: 234px;
            height: 104px;
            box-sizing: border-box;
            margin-bottom: 16px;
            &.is-selected {
              border: 2px solid #2f96ff;
            }
            .banner_show {
              height: 100%;
              width: 100%;
            }
          }
        }

        .operation-button {
          height: 120px;
          width: 56px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
          background: #ffffff;
          border: 1px solid #dfe1e6;
          box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.04);
          border-radius: 8px;
          margin-left: 24px;
          .my-icon {
            font-size: 26px;
            display: block;
            &.disabled {
              color: #ddd;
            }
          }
        }
      }
    }

    .logo.deputy {
      top: 86px;
    }
    .logo {
      position: absolute;
      max-width: 122px;
      height: 20px;
      top: 107px;
      left: 14px;
    }
    .intro {
      margin-top: 10px;
      font-size: 14px;
      color: #303133;
      text-align: center;
    }
  }
  .dialog-footer {
    width: 100%;
    display: flex;
    justify-content: center;
    ::v-deep .el-button {
      width: 160px;
    }
  }
}
</style>
